// extracted by mini-css-extract-plugin
export default {"container":"KfJ16G"};